const VERSIONS = [{ name: 'Agra', number: '0.0.1' }];

module.exports = {
  VERSIONS
};
